export const columns = [
	{
		title: '序号',
		key: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '题目类型',
		dataIndex: 'questionType',
		align: 'center',
		width: 100,
		scopedSlots: { customRender: 'questionType' },
	},
	{
		title: '题目名称',
		dataIndex: 'question',
		align: 'center',
		width: 200,
	},
	{
		title: '创建时间',
		dataIndex: 'createTime',
		align: 'center',
		width: 120,
		// scopedSlots: { customRender: 'timeRender' },
	},
	{
		title: '更新人',
		dataIndex: 'updatorName',
		align: 'center',
		width: 100,
	},
	{
		title: '更新时间',
		dataIndex: 'updateTime',
		align: 'center',
		width: 100,
		// scopedSlots: { customRender: 'timeRender' },
	},
	{
		title: '操作',
		key: 'action',
		dataIndex: 'questionId',
		align: 'center',
		width: 100,
		scopedSlots: { customRender: 'action' },
	},
]
